module.exports = __webpack_public_path__ + "img/no_hay_datos.b94fee5a.svg";